export default "<p>int-user-navbar works!</p>\r\n"